import { RouterProvider } from 'react-router-dom';
import { AuthProvider } from 'contexts/AuthContext';
import { ModeProvider } from 'contexts/ModeContext';

// project imports
import router from 'routes';
import ThemeCustomization from 'themes';

// ==============================|| APP - THEME, ROUTER, LOCAL ||============================== //

export default function App() {
  return (
    <ThemeCustomization>
      <AuthProvider>
        <ModeProvider>
          <RouterProvider router={router} />
        </ModeProvider>
      </AuthProvider>
    </ThemeCustomization>
  );
}
